import gsap from 'gsap';

const CARD_SELECTOR = '.js-team-card-click';
const BOUND_ATTR = 'data-team-card-bound';

function bindCard(card: HTMLElement): void {
  if (card.getAttribute(BOUND_ATTR) === 'true') {
    return;
  }

  const details = card.querySelector<HTMLElement>('.js-card-details-animate');
  const main = card.querySelector<HTMLElement>('.js-team-main-animate');

  if (!details || !main) return;

  card.setAttribute(BOUND_ATTR, 'true');

  gsap.set(details, { xPercent: -100 });
  gsap.set(main, { x: 0 });

  card.setAttribute('aria-expanded', 'false');
  details.setAttribute('aria-hidden', 'true');

  card.addEventListener('click', () => {
    if (card.classList.contains('is-open')) {
      closeDetails(card, details, main);
    } else {
      openDetails(card, details, main);
    }
  });
}

function getMainShiftPx(_card: HTMLElement, details: HTMLElement): number {
  return details.offsetWidth;
}

function openDetails(card: HTMLElement, details: HTMLElement, main: HTMLElement): void {
  gsap.killTweensOf([details, main]);
  const shift = getMainShiftPx(card, details);

  gsap.timeline({
    onStart: () => {
      card.classList.add('is-open');
      card.setAttribute('aria-expanded', 'true');
      details.setAttribute('aria-hidden', 'false');
    },
  })
    .to(details, { xPercent: 0, opacity: 1, duration: 0.45, ease: 'power2.out' }, 0)
    .to(main, { x: shift, duration: 0.45, ease: 'power2.out' }, 0);
}

function closeDetails(card: HTMLElement, details: HTMLElement, main: HTMLElement): void {
  gsap.killTweensOf([details, main]);

  gsap.timeline({
    onComplete: () => {
      card.classList.remove('is-open');
      card.setAttribute('aria-expanded', 'false');
      details.setAttribute('aria-hidden', 'true');
    },
  })
    .to(details, { xPercent: -100, duration: 0.4, ease: 'power2.inOut' }, 0)
    .to(main, { x: 0, duration: 0.4, ease: 'power2.inOut' }, 0);
}

export function initTeamMemberCards(): void {
  document.querySelectorAll<HTMLElement>(CARD_SELECTOR).forEach((card) => bindCard(card));
}
